
// 存储资源列表数据
export default {
  namespaced: true,
  state: {
    items: [],
  },
  mutations: {
    CHANEG_ITEM(state, item) {
      state.items = item
    },
    ADD_ITEM(state, item) {
      state.items.push(item)
      localStorage.setItem('labelArr', JSON.stringify(state.items))
    },
    DELETE_ITEM(state, id) {
      state.items = state.items.filter(item => item.id !== id)
      localStorage.setItem('labelArr', JSON.stringify(state.items))
    },
    UPDATE_ITEM(state, updatedItem) {
      const index = state.items.findIndex(item => item.id === updatedItem.id)
      if (index !== -1) {
        state.items.splice(index, 1, Object.assign({}, state.items[index], updatedItem))
      }
      localStorage.setItem('labelArr', JSON.stringify(state.items))
    }
  },
  actions: {
    changeItem({ commit }, item) {
      commit('CHANEG_ITEM', item)
    },
    addItem({ commit, state }, item) {
      const newId = state.items.length > 0 ? state.items[state.items.length - 1].id + 1 : 1
      const newItem = { ...item, id: newId }
      commit('ADD_ITEM', newItem)
    },
    deleteItem({ commit, state }, id) {
      commit('DELETE_ITEM', id)
    },
    updateItem({ commit, state }, updatedItem) {
      commit('UPDATE_ITEM', updatedItem)
    }
  }
}